import { QuoteSubjectivityPostRequestBody, QuoteSubjectivityPostResponse } from '@lio/api-types';
import { subjectivityQueryKeys } from '@services/subjectivity/keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useCreateSubjectivity = (quoteId?: string) => {
  const queryClient = useQueryClient();
  const client = useClient();
  const result = useMutation({
    mutationFn: (body: QuoteSubjectivityPostRequestBody) =>
      client
        .post(`quote/${quoteId}/subjectivity`, {
          json: {
            ...body,
          },
        })
        .json<QuoteSubjectivityPostResponse>(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: subjectivityQueryKeys.search(quoteId) });
    },
  });
  return { ...result, createManualSubjectivity: result.mutateAsync };
};
